import { Component } from "@angular/core";

@Component({
  selector: 'features-widget',
  standalone: true,
  template: `
    <section class="py-12 px-6 md:px-12 lg:px-20">
      <h2 class="text-3xl font-bold mb-8">
        Built for Real Operational Automation
      </h2>

      <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div class="feature-card">
          <h3>Deterministic Workflows</h3>
          <p>Explicit steps, branching, retries, and completion states.</p>
        </div>

        <div class="feature-card">
          <h3>Async Execution</h3>
          <p>Pause workflows, wait for APIs, humans, or vendors, then resume safely.</p>
        </div>

        <div class="feature-card">
          <h3>Validation Engine</h3>
          <p>Prevent bad data with rules, retries, and escalation policies.</p>
        </div>

        <div class="feature-card">
          <h3>Bulk & Broadcast</h3>
          <p>Start thousands of workflow instances with full state isolation.</p>
        </div>

        <div class="feature-card">
          <h3>WhatsApp Templates</h3>
          <p>Use Meta-approved templates at every step.</p>
        </div>

        <div class="feature-card">
          <h3>Human Handoff</h3>
          <p>Pause automation and route to agents when needed.</p>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .feature-card {
      border: 1px solid var(--surface-border);
      padding: 1rem;
      border-radius: var(--gh-r-sm);
    }
    .feature-card h3 {
      font-weight: 600;
      margin-bottom: 0.5rem;
    }
  `]
})
export class FeaturesWidget {}
